import { render } from "./PrintInstallmentTableDesign1.vue?vue&type=template&id=1f97ae7d&scoped=true"
import script from "./PrintInstallmentTableDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInstallmentTableDesign1.vue?vue&type=script&lang=js"

import "./PrintInstallmentTableDesign1.vue?vue&type=style&index=0&id=1f97ae7d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f97ae7d"]])

export default __exports__